<template>
  <div>
    <h3 class="h5" @click.prevent="handleClick" :class="classObject">
      <slot name="title"></slot>
    </h3>
    <slot name="content" v-if="isCollapsed"></slot>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Number
    }
  },
  computed: {
    isCollapsed: function() {
      const { collapsedIndex } = this.getAccordionState();
      return this.value === collapsedIndex;
    },
    classObject: function() {
      return {
        selected: this.isCollapsed
      };
    }
  },

  methods: {
    handleClick() {
      const { update } = this.getAccordionState();
      update(this.value);
    }
  },
  inject: ["getAccordionState"]
};
</script>
